import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { PermissionGrantEffect } from '../../services/permissionGroupsApi';

type PermissionEffectToggleProps = {
  value: PermissionGrantEffect;
  disabled?: boolean;
  onChange: (value: PermissionGrantEffect) => void;
};

function SwitchControl({
  active,
  tone,
  disabled,
  label,
  onClick,
}: {
  active: boolean;
  tone: 'allow' | 'deny';
  disabled?: boolean;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={active}
      aria-label={label}
      title={label}
      disabled={disabled}
      className={`erp-switch ${active ? `erp-switch-on erp-switch-${tone}` : ''}`}
      onClick={onClick}
    />
  );
}

export function PermissionEffectToggle({ value, disabled = false, onChange }: PermissionEffectToggleProps) {
  const allowOn = value === 'allow';
  const denyOn = value === 'deny';

  return (
    <div className="erp-permission-toggles">
      <div className="erp-permission-toggle">
        <CheckIcon className="erp-permission-toggle-icon erp-permission-toggle-icon-allow" aria-hidden />
        <SwitchControl
          active={allowOn}
          tone="allow"
          disabled={disabled}
          label="Permitir"
          onClick={() => onChange(allowOn ? 'none' : 'allow')}
        />
      </div>
      <div className="erp-permission-toggle">
        <XMarkIcon className="erp-permission-toggle-icon erp-permission-toggle-icon-deny" aria-hidden />
        <SwitchControl
          active={denyOn}
          tone="deny"
          disabled={disabled}
          label="Negar"
          onClick={() => onChange(denyOn ? 'none' : 'deny')}
        />
      </div>
    </div>
  );
}
